import React from 'react';

const Housebets = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "28",
    height: "29",
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14 26.3214C20.6274 26.3214 26 20.9488 26 14.3214C26 7.69393 20.6274 2.32135 14 2.32135C7.37258 2.32135 2 7.69393 2 14.3214C2 20.9488 7.37258 26.3214 14 26.3214Z",
      fill: "#00FFFF"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.8946 9.426V19.2161H15.4136V15.4098C15.4136 15.3885 15.4085 15.3675 15.3989 15.3485C15.3892 15.3294 15.3751 15.313 15.3578 15.3005L14.0531 14.3588C14.0377 14.3478 14.0193 14.3418 14.0004 14.3418C13.9815 14.3418 13.9631 14.3478 13.9478 14.3588L12.643 15.3005C12.6258 15.313 12.6117 15.3294 12.602 15.3485C12.5923 15.3675 12.5873 15.3885 12.5873 15.4098V19.2161H9.10449V9.4278H12.5855V13.0613H15.4136V9.426H18.8946Z",
      fill: "black"
    }
  )
);

export { Housebets };
//# sourceMappingURL=Housebets.js.map
